<div *ngIf="loading" class="text-center my-4">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div *ngIf="!loading">
  <div *ngIf="claimsList && claimsList.length > 0" class="table-responsive bg-white">
    <div class="mb-3 text-secondary small">
      View all of your claims below. Click on a claim number to view more details.
    </div>
    <table class="table align-middle mb-0 custom-portal-table">
      <thead>
        <tr>
          <th class="px-3">Claim Number</th>
          <th>File Date</th>
          <th>Filed Claim Amount</th>
          <th>Paid Amount</th>
          <th>Check/Electronic Deposit Num</th>
          <th>Check/Electronic Deposit Date</th>
          <th>Tracking #</th>
          <th class="text-center px-3">Claim Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let claim of claimsList">
          <td class="px-3">
            <a href="#" (click)="$event.preventDefault(); navigateToClaimDetails(claim)"
              class="claim-link font-weight-bold">
              {{ claim.claimNumber }}
            </a>
          </td>
          <td class="text-dark-custom">{{ claim.fileDate | date:'MM/dd/yy' }}</td>
          <td class="text-dark-custom">
            <ng-container *ngIf="claim.claimAmount_Ext">
              {{ +claim.claimAmount_Ext.toLowerCase().replace('usd', '').trim() | currency:'USD':'symbol':'1.2-2' }}
            </ng-container>
            <ng-container *ngIf="!claim.claimAmount_Ext">N/A</ng-container>
          </td>
          <td class="text-dark-custom">
            <ng-container *ngIf="claim.totalPayments">
              {{ claim.totalPayments.amount | currency:(claim.totalPayments.currency | uppercase):'symbol':'1.2-2' }}
            </ng-container>
            <ng-container *ngIf="!claim.totalPayments">N/A</ng-container>
          </td>
          <td class="text-dark-custom">
            {{ (claim.checkNumber && claim.checkNumber[0]) ? claim.checkNumber[0] : 'N/A' }}
          </td>
          <td class="text-dark-custom">
            <ng-container *ngIf="claim.checkIssueDate && claim.checkIssueDate[0]">
              {{ +claim.checkIssueDate[0] | date:'MM/dd/yy' }}
            </ng-container>
            <ng-container *ngIf="!claim.checkIssueDate || !claim.checkIssueDate[0]">N/A</ng-container>
          </td>
          <td class="text-dark-custom">
            {{ (claim.shippingDetails?.trackingNumber | uppercase) || 'N/A' }}
          </td>
          <td class="px-3" *ngIf="claim.customerDisplayStatus === 'Documents Pending'">
            <span class="default-style pending-button" (click)="$event.preventDefault(); navigateToClaimDetails(claim)"
              [ngClass]="{ 'status-badge-documents': claim.customerDisplayStatus === 'Documents Pending' }">
              {{ claim.customerDisplayStatus }}
            </span>
          </td>
          <td class="text-center px-3" *ngIf="claim.customerDisplayStatus !== 'Documents Pending'">
            <span class="default-style" [ngClass]="{
                'status-badge-paid': claim.customerDisplayStatus?.toLowerCase() === 'paid',
                'status-badge-open': claim.customerDisplayStatus?.toLowerCase() !== 'paid',
                'status-badge-received': claim.customerDisplayStatus === 'Claim Received',
                'status-badge-closed': claim.customerDisplayStatus === 'Closed',
                'status-badge-withdrawn': claim.customerDisplayStatus === 'Withdrawn',
                'status-badge-submitted': claim.customerDisplayStatus === 'Submitted for Payment',
                'status-badge-incomplete': claim.customerDisplayStatus === 'Incomplete Submission',
                'status-badge-investigation': claim.customerDisplayStatus === 'Investigation Pending',
                'status-badge-deliveryconfirmation': claim.customerDisplayStatus === 'Pending Delivery Confirmation',
                'status-badge-denied': claim.customerDisplayStatus === 'Denied',
                'status-badge-validdelivery': claim.customerDisplayStatus === 'Valid Delivery Denial',
                'status-badge-pendingreview': claim.customerDisplayStatus === 'Denied – Pending Review',
                'status-badge-denialconfirmed': claim.customerDisplayStatus === 'Denial Confirmed'
              }">
              {{ claim.customerDisplayStatus || 'Open' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!claimsList || claimsList.length === 0" class="text-center py-5 bg-white border rounded">
    <h5 class="text-secondary font-weight-bold mb-0">No claims found</h5>
  </div>
</div>